import { styled } from 'styled-components';

import { colors, cssBreakpoints, fontWeights } from '#/theme/theme';

export const DetailsListItemHolder = styled.div`
  display: flex;
  gap: 8px;
`;

export const DetailsListItemBody = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
`;

export const DetailsListItemValue = styled.div`
  display: flex;
  align-items: center;
`;

export const DetailsListItemFirstLine = styled.div`
  display: flex;
  align-items: baseline;
  color: ${colors.darkContentGrey};

  @media (max-width: ${cssBreakpoints.xsDown}) {
    flex-direction: column;
    align-items: start;
  }
`;

export const DetailsListItemTitle = styled.span`
  font-weight: ${fontWeights.semiBold};
  margin-right: 4px;
`;

export const DetailsListItemAdditionalText = styled.div`
  color: ${colors.lightContentGrey};
  font-weight: ${fontWeights.semiBold};
  font-style: italic;
`;
